/**
 * The default ARIA label for the WeekNumber element.
 */
export var labelWeekNumber = function labelWeekNumber(n) {
  return "Week n. " + n;
};